import * as React from "react";
import medal_1 from "../../../../assets/images/1st place medal.png";
import medal_2 from "../../../../assets/images/2nd place medal.png";
import medal_3 from "../../../../assets/images/3rd place medal.png";
import mark from "../../../../assets/images/Thumbs up.svg"

const TopPerformers = ({excellentStudentList}) => {
    return (
        <div className="flex flex-col px-5 py-6 h-full mx-auto w-full text-xl font-black bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:px-5 max-md:mt-5">
            <div className="flex gap-2 self-start text-base text-zinc-600 max-md:ml-1">
                <img
                    loading="lazy"
                    src={mark}
                    alt="Top performers icon"
                    className="object-contain shrink-0 aspect-square w-[34px]"
                />
                <div className="my-auto text-base basis-auto text-left font-black">
                    정확도 우수 학생들을 선발했어요.
                </div>
            </div>
            <div className="ml-11 text-sm font-medium text-neutral-400 text-left ">
                AI가 학급 정확도 1,2,3등을 빠르게 <br />
                알려드려요.
            </div>
            {
                excellentStudentList.map((student, index) => {
                    if(student.accuracy>=80){

                        // 순위별 메달 매핑
                        const medalImages = [medal_1, medal_2, medal_3];
                        const medalSrc = index < medalImages.length ? medalImages[index] : null;

                        return (
                            <div key={index} className="flex gap-3 px-5  min-h-[60px] mt-3 w-full text-center whitespace-nowrap rounded-lg bg-neutral-100 max-md:pr-5">
                                {medalSrc && (
                                    <img
                                        loading="lazy"
                                        src={medalSrc}
                                        alt={`Rank ${index + 1} medal`}
                                        className="object-contain shrink-0 w-8 aspect-square"
                                    />
                                )}
                                <div className="flex gap-2 items-center my-auto">
                                    <div className="flex-1 shrink gap-2 self-stretch my-auto text-zinc-600 w-[140px] text-ellipsis whitespace-nowrap overflow-hidden text-left">
                                        {student.name}
                                    </div>
                                    <div className="gap-2 self-stretch my-auto text-zinc-400 w-[60px]">
                                        {student.accuracy}%
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })}
        </div>
    );
}

export default TopPerformers;